import React, { FC } from 'react';

import { ProductImageCard } from 'components/ProductImageCard/ProductImageCard';
import { useUrlBuilder } from 'hooks/useUrlBuilder';
import { SearchResult } from 'models/search';

import { Info } from '../pages/ProductList/ProductListingCard/Info';

const maxImageHeight = '227px';
const imageContainerClassName = 'pr-card-small-img-container';
const minHeightToImageWidthRatio = 1.35;

export const ProductListingCardSmall: FC<{
  isHome?: boolean;
  product: SearchResult;
}> = ({ isHome, product }) => {
  const { localized, withTrailingSlash } = useUrlBuilder();

  return (
    <>
      <a className="link" href={withTrailingSlash(localized(product.url))}>
        <div className="product-card">
          <div className="image">
            <ProductImageCard
              imageContainerClassNames={[imageContainerClassName]}
              images={product.imagesList}
              lazyLoad
              left={'initial'}
              maxHeight="100%"
              product={product}
              width="auto"
            />
          </div>
          <Info isHome={isHome} product={product} />
        </div>
      </a>

      <style jsx>{`
        .link {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 100%;
        }
        .link:hover {
          text-decoration: none;
        }

        .product-card {
          text-align: center;
          width: 100%;

          //Pointer events must be blocked for nodes inside the anchor block, so that the link works in PDP carousel
          pointer-events: ${isHome ? 'auto' : 'none'};

          padding: 0 40px;
        }

        .product-card .image {
          margin-bottom: 15px;
        }

        @media (max-width: 1023px) {
          :global(.${imageContainerClassName}) {
            min-height: min(calc((100vw - 80px) * ${minHeightToImageWidthRatio} / 2), ${maxImageHeight});
          }
          .product-card {
            padding: 0 10px;
          }
        }

        @media (min-width: 1024px) {
          :global(.${imageContainerClassName}) {
            height: ${maxImageHeight};
            min-height: min(calc((100vw - 80px) * ${minHeightToImageWidthRatio} / 2), ${maxImageHeight});
          }
        }

        :global(.${imageContainerClassName}) {
          display: flex;
          justify-content: center;
        }
      `}</style>
    </>
  );
};
